<template>
    <div class="container" id="servicios">
        <div class="header">
            <h2>CONOZCA NUESTROS SERVICIOS</h2>
        </div>
        
        <div class="row">
            <div class="col-md-4">
                <div class="card">
                    <img class="card-img-top mx-auto d-block" src="/static/home/icono1.png" alt="Card image cap">
                    <div class="card-block text-justify">
                        <p class="card-text" style="font-size: 15px;">Somos parte de un mundo globalizado,
                            un mundo en constante movimiento. No alcanza con adaptarse a los cambios... 
                            hay que anticiparse a ellos. Para lograrlo, resulta imprescindible participar activamente
                            y mantenerse informado de las últimas tendencias en el mercado local, nacional, regional e internacional.</p>
                        <p class="card-text text-justify" style="font-size: 13px;">
                            Con <b>WPO</b> dispones de una plataforma para comprar y vender autopartes con cobertura/alcance
                            sobre todo el territorio nacional. Además, te mantendremos al tanto de las últimas noticias,
                            informes y acontecimientos relacionados a este segmento.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="card">
                    <img class="card-img-top mx-auto d-block" src="/static/home/icono2.png" alt="Card image cap">
                    <div class="card-block text-justify">
                        <p class="card-text" style="font-size: 15px;">
                            El mercado de autopartes está compuesto por repuestos, recambios y accesorios varios
                            destinados a todo tipo de vehículos (automóviles, motocicletas, trasporte pesado y de pasajeros).
                            Tanto nuevos o usados, como originales u alternativos.   
                        </p>
                        <p class="card-text text-justify" style="font-size: 13px;">
                            Con <b>WPO</b> tenés acceso a todo este abanico de posibilidades, agrupadas y ordenadas
                            según tus preferencias, para que siempre encuentres aquello que estás buscando... 
                            para que siempre llegues primero al cliente.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="card">
                    <img class="card-img-top mx-auto d-block" src="/static/home/icono3.png" alt="Card image cap">
                    <div class="card-block">
                        <p class="card-text text-justify" style="font-size: 15px;">
                            Con el surgimiento de internet, los requerimientos han cambiado. 
                            El mercado cuenta con mayor acceso a la información y por lo tanto, 
                            con más herramientas para comparar ofertas y escoger por aquello que
                            mejor se adapte a sus necesidades.
                            Frente a este escenario, el comercio electrónico se ha convertido
                            en una pieza clave para el crecimiento y expansión de cualquier negocio.
                            Contar con este canal de ventas, significa aumentar tus probabilidades de éxito.
                        </p>
                        <p class="card-text text-justify" style="font-size: 13px;">
                            En <b>WPO</b> dispones de un sistema e-commerce con estándares universales.
                            Mediante una interface ágil, intuitiva y personalizable, te facilitaremos
                            la interacción con tus clientes y/o proveedores ahorrándote tiempo
                            para que optimices cada transacción. 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home-servicios',
    
    data () {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Home-Servicios.vue?06af0ae1